import { autoMount } from '../../../utils/autoMount';
import { CompanyRecruitment } from '../../../components/organisms/companyRecruitment';

autoMount({ CompanyRecruitment });
